import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElSwitch } from 'element-plus';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'Toggle',
  props: /*@__PURE__*/_mergeModels({
    activeText: {},
    inactiveText: {},
    disabled: { type: Boolean, default: false }
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



// Store the value
const value = _useModel<boolean>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElSwitch), {
    class: "toggle",
    "active-text": _ctx.activeText,
    "inactive-text": _ctx.inactiveText,
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    disabled: _ctx.disabled
  }, null, 8, ["active-text", "inactive-text", "modelValue", "disabled"]))
}
}

})